import { useState, useRef, ReactNode } from 'react';
import { Tooltip as BTooltip, Overlay } from 'react-bootstrap';

interface HoverTooltipProps {
    children: ReactNode;
    content: ReactNode | null;
    placement?: 'top' | 'right' | 'bottom' | 'left';
    className?: string;
    style?: React.CSSProperties;
}

export default function TooltipOverlay({
    children,
    content,
    placement = 'top',
    className = '',
    style,
}: HoverTooltipProps) {
    const [show, setShow] = useState(false);
    const target = useRef<HTMLElement | null>(null);

    return (
        <>
            <span
                ref={target as any}
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
                className={`d-flex cursor-pointer ${className}`}
                style={style}
            >
                {children}
            </span>
            {content && (
                <Overlay target={target.current} show={show} placement={placement}>
                    {props => <BTooltip {...props}>{content}</BTooltip>}
                </Overlay>
            )}
        </>
    );
}
